import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-accolade-logo.css.lit';
import '../se-link/se-link';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The SeAccoladeLogo component
 * @element se-accolade-logo
 */
@customElement('se-accolade-logo')
export class SeAccoladeLogo extends OutlineElement {
  slots = new SlotController(this, true);
  static styles: CSSResultGroup = [componentStyles];
  hover = false;

  @property({ type: String, attribute: 'link-text' })
  linkText: string;

  @property({ type: String, attribute: 'link-url' })
  linkUrl: string;

  render(): TemplateResult {
    return html`
      <div class="se-accolade-logo">
        <div class="logo">
          <slot name="logo"></slot>
        </div>
        <se-link>
          <a href="${this.linkUrl}" class="link">
            ${this.linkText}
            <outline-icon
              color="brand-primary-2"
              library="system"
              name="arrow-right"
              size="0.75em"
              class="${this.hover ? 'hover' : ''}"
            >
            </outline-icon>
          </a>
        </se-link>
      </div>
    `;
  }
}
